"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGetPhaseBreakdown extends new_item_1.default {
    constructor(newGetPhaseBreakdown) {
        super();
        this.assetId = newGetPhaseBreakdown.assetId;
    }
}
exports.default = NewGetPhaseBreakdown;
//# sourceMappingURL=new-getPhaseBreakdown.js.map